export const basicPermittedRoutes = [
    "/news",
    "/blogs",
    "/banners",
    "/orders",
    "/quotations",
]